export default __webpack_public_path__ + "static/media/highSkip.f8fbbde1.png";